import styled from "styled-components";

interface ITableProps {
    $hideHeaders?: boolean
}

export default styled.table<ITableProps>`
    border-collapse: collapse;
    border-style: hidden;

    th, td {
        border: 1px solid #00000007;
        font-size: 1rem;
        padding: 0;
    }

    tbody th, td {
        padding: 6px 8px;
    }

    thead {
        &:hover {
            th {
                border-left-color: #0004;
                border-right-color: #0004;
            }
        }

        button {
            align-items: center;
            border: none;
            background: transparent;
            color: #000d;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            font-size: 1rem;
            font-weight: bold;
            margin: 0;
            padding: 6px 8px;
            user-select: none;
            white-space: nowrap;
            width: 100%;
        }
    }

    tbody {
        tr:has(th:only-child) {
            cursor: default;
            display: ${ ({ $hideHeaders }) => $hideHeaders ? "none" : "table-row" };
            text-align: left;

            &:hover {
                background: transparent;
            }
        }

        tr:not(:has(th:only-child)):hover {
            background: #00000007;
        }

        td {
            border-left-color: transparent;
            border-right-color: transparent;
        }
    }
`;
